export const numberPattern = `^[0-9]+$`;
export const namePattern = `^[a-zA-Z0-9 &'-@]+$`;
export const alphabetPattern = `^[A-Za-z &'-]+$`;
export const fileNamePattern = /^[a-zA-Z0-9 _.,!()@#&;'+~[\]{}=$%^\-]*$/;